import { render, staticRenderFns } from "./BCXDatePickerYear.vue?vue&type=template&id=01f05c44"
import script from "./BCXDatePickerYear.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDatePickerYear.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDatePickerYear.vue?vue&type=style&index=0&id=01f05c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports